import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'journeyduration'
})
export class JourneydurationPipe implements PipeTransform {

  // transform(flights: any[]): number {
  //   if (!Array.isArray(flights)) return 0;
  //   return flights
  //     .map(flight => flight.journeyduration)
  //     .filter(duration => typeof duration === 'number')
  //     .reduce((a, b) => a + b, 0);
  // }

  transform(flights: any[]): number {
    if (!Array.isArray(flights)) return 0;

    let totalDuration = 0;

    flights.forEach(flight => {
      if (typeof flight.journeyduration === 'number') {
        totalDuration += flight.journeyduration;
      }
      if (flight.layover__ && typeof flight.layover__ === 'object') {
        for (const key in flight.layover__) {
          const layoverSeconds = flight.layover__[key];
          if (typeof layoverSeconds === 'number') {
            const layoverMinutes = Math.round(layoverSeconds / 60);
            // console.log(`Layover at ${key}: ${layoverMinutes} min`);
            totalDuration += layoverMinutes;
          }
        }
      }
    });

    return totalDuration;
  }

}
